import { UpgradeReport } from '@/types/upgradereport';
import { UpgradeReportType } from '@/types/upgradereporttype';

export enum UpgradeJobType {
    SETTINGS = 'SETTINGS',
    AKK = 'AKK',
    ASCAD = 'ASCAD',
    TUNES = 'TUNES',
    TUNES_DEBITS = 'TUNES_DEBITS',
    QUALIFICATIONS = 'QUALIFICATIONS',
    REWARDS = 'REWARDS',
    LINKED_ACCOUNTS = 'LINKED_ACCOUNTS'
}

export class UpgradeJob {
    public id: UpgradeJobType;

    public reports:Array<UpgradeReportType> = [];

    constructor(id:UpgradeJobType,
      reports:Array<UpgradeReportType>) {
      this.id = id;
      this.reports = reports;
    }
}
